/* eslint-disable no-restricted-syntax */
import { useEffect, useRef } from 'react'

const events = ['mousedown', 'touchstart']

const useClickAway = handler => {
  const ref = useRef(null)

  useEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }

    const handleEvent = e => {
      !element.contains(e.target) && handler(e)
    }

    events.map(event => document.addEventListener(event, handleEvent))

    return () =>
      events.map(event => document.removeEventListener(event, handleEvent))
  })

  return ref
}

export default useClickAway
